
export default {
    add: (productT,emitter,notify,cookies,router) => {
      let COMPARES = localStorage.getItem("compares") ? JSON.parse(localStorage.getItem("compares")) : [];//cookies.get("compares") ? cookies.get("compares") : [];

      let INDEX = COMPARES.findIndex(product => product.uniqd == productT.uniqd);
      if(COMPARES.length >= 5){
        notify({
            title: "Solo se puede agregar 5 productos como maximo",
            // text: `Tu producto '${productT.title}' ya se encuentra en la lista de comparación!`,
            type:'error',
            duration: 3500,
        });
        return;
      }
      if(INDEX != -1){
          notify({
              title: "El Producto ya se encuentra en la lista de comparación",
              // text: `Tu producto '${productT.title}' ya se encuentra en la lista de comparación!`,
              type:'error',
              duration: 3500,
          });
          return;
      }else{
          COMPARES.push({
            title: productT.title ,
            imagen: productT.image,
            image: productT.image,
            uniqd: productT.uniqd ,
            id: productT.id,
            slug: productT.slug ,
            summary: productT.summary ,
            avg_rating: productT.avg_rating,
            reviews_count: productT.reviews_count,
            categorie_first: productT.categorie_first,
            categorie_second: productT.categorie_second,
            categorie_third: productT.categorie_third,
            precio_general: productT.precio_general,
          });
      }

      // cookies.set('compares',COMPARES);
      localStorage.setItem('compares',JSON.stringify(COMPARES));
      emitter.emit('compare-product', COMPARES);
      notify({
          title: "Producto agregado a comparar",
          // text: `Tu producto '${productT.title}' se agrego a la lista de comparación!`,
          duration: 3500,
          type:'success',
      });
      setTimeout(() => {
        if(COMPARES.length > 1){
            router.push({
              name: 'CompareProduct',
            })
        }
      }, 25);
    },
}